import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-company-logo',
  standalone: true,
  imports: [CommonModule],
  template: `
    <a href="/">
      <img *ngIf="!isSmall" class="logo-new" src="/assets/img/obt-logo-gruppe.png" alt="obt-logo-gruppe" loading="lazy" />
      <img *ngIf="isSmall" src="/assets/img/obt-logo-1.png" alt="obt-logo-gruppe" />
    </a>
  `,
  styles: [
    `
      :host {
        display: block;
        .logo-new {
          height: 50px;
          width: auto;
        }
      }
    `,
  ],
})
export class CompanyLogoComponent {
  @Input() isSmall?: boolean;
}
